import { useTranslation } from 'react-i18next';

import ResultObject from '../interfaces/result-object';
import { ResultTab } from '../interfaces/result-tab';
import '../styles/feedback.scss';

interface FeedbackProps {
  endTestResult: ResultObject;
  onSetActiveTab?: (tab: ResultTab) => void;
}

const Feedback: React.FC<FeedbackProps> = ({ endTestResult, onSetActiveTab }) => {
  const { t } = useTranslation();
  const viewReportButtonLabel = t(`button.viewReport`);
  const contentButtonLabel = t(`button.keepLearning`);
  return (
    <div key="result" className="result-block centered">
      {endTestResult.score && (
        <div className="result-block-score">
          <div className="result-percentage">{endTestResult.score}</div>
        </div>
      )}
      <h1>{endTestResult.message?.title}</h1>
      <div>{endTestResult.message?.body}</div>
      <div className="result-buttons-container">
        <a className="oejr-btn outline" href={endTestResult.redirectTo} target="_top">
          {contentButtonLabel}
        </a>
        {!!onSetActiveTab && (
          <button className="oejr-btn" onClick={() => onSetActiveTab('report')}>
            {viewReportButtonLabel}
          </button>
        )}
      </div>
    </div>
  );
};

export default Feedback;
